import { GraphEdge, GraphFilters, GraphVertex } from '../types';
import { getPackId } from '../utils/packUtils';
import filterVertex from './filterVertex';
import packVertices, { Pack } from './packVertices';
import remapVerticesAndEdgesWithPacks from './remapVerticesAndEdgesWithPacks';

export interface GraphData {
  vertices: GraphVertex[];
  edges: GraphEdge[];
  filters: GraphFilters;
}

export interface ReducedGraphData {
  vertices: GraphVertex[];
  edges: GraphEdge[];
  allPacks: Pack[];
}

const reduceGraphData = ({ vertices, edges, filters }: GraphData) => {
  // Only run this when either new nodes are added (only run on the new nodes) or when filters change
  const filteredVertices = vertices.filter((v) => filterVertex(v, filters));

  const allPacks = packVertices(filteredVertices, edges);
  const shownPacks = allPacks.filter(
    (p) => filters.unpackedPacks.indexOf(getPackId(p)) === -1
  );
  return {
    ...remapVerticesAndEdgesWithPacks(filteredVertices, edges, shownPacks),
    allPacks,
  };
};

export default reduceGraphData;
